import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updatePostTag } from "../../../api/apiBlog";
import { toast } from "react-hot-toast";
import parseError from "../../../utils/parseError";
import { useNavigate } from "react-router-dom";

export const useUpdatePostTag = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();
    const { mutate: updateTagMutate, isPending: isUpdating } = useMutation({
        mutationFn: ({ id, data }) => updatePostTag(id, data),
        onSuccess: (res) => {
            toast.success(res.message || "Tag updated successfully");
            queryClient.invalidateQueries(["post-tags"]);
            navigate("/blog/tags");
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to update tags");
        },
    });

    return { updateTagMutate, isUpdating };
};
